import { defineStore } from 'pinia';

import state from './state';
import actions from './actions';
import getters from './getters';

export const useAdminStore = defineStore({ id: 'customer', state, actions, getters });
